import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';

import {
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
// import { CommonService } from 'src/app/services/common.service';
import { OpenPoService } from 'src/app/services/open-po.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InteractionType } from '@azure/msal-browser';
import { AppConfigService } from 'src/app/services/app.config.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonService } from '../common.service';

@Component({
    selector: 'app-azure-login',
    templateUrl: './app-azure-login-dialog.component.html',
    styleUrls: ['./app-azure-login-dialog.component.scss']
})
export class AppAzureLoginDialogComponent implements OnInit, OnDestroy, AfterViewInit {
    public azureForm = new FormGroup({
        email: new FormControl(localStorage.getItem('email')),
        panCode: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/)])
    });
    logo: string = '';
    private onDestroy$ = new Subject();
    @ViewChild('emailInput') emailInput!: ElementRef;

    constructor(
        public DialogRef: MatDialogRef<AppAzureLoginDialogComponent>,
        private openPoService: OpenPoService,
        private appConfigService: AppConfigService,
        private commonService: CommonService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
        private authService: MsalService,
    ) { }

    ngOnInit(): void {
        this.logo = this.appConfigService.get('logoUrl');
    }

    ngAfterViewInit() {
        this.emailInput?.nativeElement.focus();
    }

    async checkPan() {
        this.azureForm.value.panCode;
        this.azureForm.value.email = localStorage.getItem("email");
        this.openPoService.GetUserStatusByEmail(localStorage.getItem('email') || '').subscribe((res: any) => {
            if (!res.data['getUserStatusByEmail']) {
                this.commonService.openSnackBar("User is Inactive", "");
                return
            } else {
                this.openPoService.GetPanByEmail(localStorage.getItem("email") || '').subscribe((res: any) => {
                    const pan = res?.data['getPanByEmail'].map((x: any) => x.vendorPan);
                    if (pan && pan.length > 0 && (pan?.includes(this.azureForm.value.panCode))) {
                        this.openPoService.InviteStatusUpdate(localStorage.getItem("email") || '').subscribe(res => {
                            localStorage.setItem("azurePanVerifyStatus", "Success")
                            this.commonService.openSnackBar("PAN verified Sucessfully", "");
                            localStorage.setItem("panNo", this.azureForm.value.panCode)
                            this.DialogRef.close(true);
                        });
                    }
                    else {
                        this.commonService.openSnackBar("PAN not matched", "OK", 3000, "warn-snackbar");

                    }

                })
            }
        });

    }
    logout() {
        localStorage.clear();
        if (this.msalGuardConfig.interactionType === InteractionType.Redirect) {
            this.authService.logoutRedirect({
                postLogoutRedirectUri: "/",
                // mainWindowRedirectUri: "/"
            });
        } else {
            this.authService.logoutRedirect({
                postLogoutRedirectUri: "/",
            });
        }
    }

    onLoginClick() {
        this.openPoService.InviteStatusUpdate(localStorage.getItem("email") || '').pipe(takeUntil(this.onDestroy$)).subscribe(res => {
            localStorage.setItem("azurePanVerifyStatus", "NotApplicable");
            this.DialogRef.close(true);
        });
    }

    ngOnDestroy(): void {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
}
